import { Entry } from '../Entry'

export function Entry20240925() {
  return (
    <Entry title="25/09/2024 - v3.8.4">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/16037/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
